import { render, staticRenderFns } from "./forced-reminder.vue?vue&type=template&id=5d98ef21&"
import script from "./forced-reminder.vue?vue&type=script&lang=js&"
export * from "./forced-reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports